module.exports = __webpack_public_path__ + "img/audio.fe25dc82.png";